import React, { useEffect, useState } from "react";
import styles from "../../assets/styles/Components/AppShell.module.scss";
import Sidebar from "../Sidebar";
import { useNavigate } from "react-router-dom";
import constant from "../../utils/constant";
import { motion, AnimatePresence } from "framer-motion";
import { FaBars } from "react-icons/fa";
import IconButton from "../IconButton";
import { LogoutModal } from "..";
import CountDown from "../CountDown";
import { appStore, businessStore } from "../../stores";
import { Subscriptions } from "../../pages";
import DisputeTerms from "../Dispute/DisputeTerms";
import { observer } from "mobx-react";

const AppShell = ({ children, pageTitle, tradingName }) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [subscriptionModal, setSubscriptionModal] = useState(false);

  const [openModal, setOpenModal] = useState("");

  const openModalHandler = (modal) => {
    setOpenModal(modal);
  };

  const modalConstant = {
    logout: "LOGOUT",
    dispute: "DISPUTE",
    subscription: "SUBSCRIPTION",
  };

  const closeModal = () => {
    setOpenModal("");
  };

  const navigate = useNavigate();
  const goToSettings = () => {
    navigate(constant.Routes.Settings);
  };

  const [logoutModal, setLogoutModal] = useState(false);

  const goTologout = () => {
    openModalHandler(modalConstant.logout);
  };

  const menuClicked = () => {
    setShowSidebar(!showSidebar);
  };

  //  For free trial
  const subscriberList = businessStore.business?.subscription;
  const subscriptionAmount = subscriberList?.amountPaid;
  const startDate = subscriberList?.trialStartDate;

  const acceptedDisputePolicy = appStore.generalSettings.disputePolicy;

  useEffect(() => {
    if (!acceptedDisputePolicy) {
      openModalHandler(modalConstant.dispute);
    }
  }, []);

  return (
    <div className={styles.container}>
      {showSidebar && (
        <motion.div
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
            transition: {
              duration: 0.2,
            },
          }}
          exit={{
            opacity: 0,
            transition: {
              duration: 0.2,
            },
          }}
          className={styles.sidebar}
        >
          <motion.div
            initial={{
              x: -100,
            }}
            animate={{
              x: 0,
              transition: {
                duration: 0.2,
              },
            }}
            exit={{
              x: -100,
              transition: {
                duration: 0.2,
              },
            }}
          >
            <Sidebar menuClicked={menuClicked} />
          </motion.div>
          <div onClick={menuClicked}></div>
        </motion.div>
      )}
      <div className={styles.topside}>
        <div className={styles.topside_left}>
          <FaBars className={styles.menuIcon} onClick={menuClicked} />
          {pageTitle !== "" ? (
            <h3> {pageTitle} </h3>
          ) : (
            <p className={styles.topside_welcome}>
              Welcome back, <br />
              <span className={styles.topside_name}>
                {tradingName ? tradingName : ""}
              </span>
            </p>
          )}
        </div>

        <div className={styles.topside_icon}>
          <IconButton onClick={goToSettings} />
          <IconButton variant="logout" onClick={goTologout} />
        </div>
      </div>
      <CountDown
        startDate={startDate}
        subscriptionAmount={subscriptionAmount}
        subscriberList={subscriberList}
        goToSubscription={() => {
          openModalHandler(modalConstant.subscription);
        }}
      />

      <div>{children}</div>

      {openModal !== "" && (
        <div className="modal">
          <AnimatePresence>
            {openModal === modalConstant.logout && (
              <LogoutModal closeModal={closeModal} />
            )}

            {openModal === modalConstant.dispute && (
              <DisputeTerms closeModal={closeModal} />
            )}
            {openModal === modalConstant.subscription && (
              <Subscriptions closeModal={closeModal} />
            )}
          </AnimatePresence>
        </div>
      )}
    </div>
  );
};

export default observer(AppShell);
